import configStore from '@/store/configStore'

export const baseUrl = configStore.getters.baseUrl;